/**
 * Phone capture on the shared kundali form. Owner decision 2026-09-24: phone is
 * OPTIONAL everywhere — a seeker can generate a chart and chat without one. A
 * phone that is typed is still validated (E.164) and saved as the reading's
 * contact. Marketing consent stays a separate explicit action (ADR-0043 §3):
 * saving a contact never opts anyone into marketing.
 */
export const KUNDALI_PHONE_CAPTURE_POLICY = Object.freeze({
  required: false,
  consentMarketing: false,
});
